import {
    CLEAR_OPPONENT_SELECTION,
    COMPANY_OPPONENT_STATISTICS_FETCH,
    COMPANY_OPPONENT_STATISTICS_FETCH_SUCCESS,
    COMPANY_SEARCH_RESULT_SUCCESS,
    COMPANY_STATISTICS_FETCH,
    COMPANY_STATISTICS_FETCH_SUCCESS,
    COUNT_PER_COUNTRIES_BY_ACTIVE_SUBSTANCE_SUCCESS,
    COUNT_PER_COUNTRIES_BY_BRAND_NAME_SUCCESS,
    DRUG_COUNT_PER_COUNTRY_FETCH_SUCCESSFULLY,
    DRUG_FETCH_SUCCESSFULLY,
    DRUG_LOADING,
    DRUGS_COUNT_PER_MANUFACTURER_FETCH_SUCCESSFULLY,
    DRUGS_COUNTRY_ATC,
    DRUGS_FETCH_SUCCESSFULLY,
    DRUGS_LOADING
} from "./actionTypes";
import axios from '../../http/axios'


export const getDrugsCountPerCountry = () => dispatch => {
    axios.get(`/drugs/count-per-country`)
        .then(data => {
            let result = {};
            let count = 0;
            let no_countries = 0
            data.data.forEach(element => {
                if (element) {
                    result[element.countryCode] = element.drugsCount;
                    count += element.drugsCount;
                    no_countries++;
                }
            });
            dispatch({
                type: DRUG_COUNT_PER_COUNTRY_FETCH_SUCCESSFULLY,
                payload: {
                    drugsPerCountry: result,
                    drugsCount: count,
                    countriesCovered: no_countries
                }
            });
        });
};

export const getDrugs = (page, pageSize, sort, filter) => dispatch => {
    dispatch({type: DRUGS_LOADING});
    axios.get("/drugs", {
        params: {
            page,
            pageSize,
            sortKey: sort.sortKey,
            sortDirection: sort.direction,
            countryCode: filter.countryCode,
            atcLetter: filter.atcLetter,
            activeSubstance: filter.activeSubstance.toLowerCase(),
            manufacturer: filter.manufacturer.toLowerCase(),
            brandName: filter.brandName.toLowerCase(),
            genericName: filter.genericName.toLowerCase()
        }
    })
        .then(data => {
            dispatch({
                type: DRUGS_FETCH_SUCCESSFULLY,
                payload: {drugs: data.data.drugs, totalDrugs: data.data.totalCount}
            })
        })
        .catch(error => console.warn(error));
};

export const getDrug = (id) => dispatch => {
    dispatch({type: DRUG_LOADING});
    axios.get("/drugs/" + id)
        .then(response => {
            dispatch({type: DRUG_FETCH_SUCCESSFULLY, payload: response.data})
        })
        .catch(error => console.warn(error))
};

export const getStatisticsForActiveSubstance = (id) => dispatch => {
    axios.get("/drugs/statistics/count-per-countries-for-active-substance", {params: {drugId: id}})
        .then(response => {
            let data = {
                label: 'ACTIVE SUBSTANCE STATISTICS', values: response.data.map((val) => {
                    return {
                        x: val.countryCode,
                        y: val.count
                    }
                })
            };
            dispatch({type: COUNT_PER_COUNTRIES_BY_ACTIVE_SUBSTANCE_SUCCESS, payload: data});
        })
        .catch(error => console.warn(error))
};

export const getStatisticsForBrandName = (id) => dispatch => {
    axios.get("/drugs/statistics/count-per-countries-for-brand-name", {params: {drugId: id}})
        .then(response => {
            let data = {
                label: 'BRAND NAME STATISTICS', values: response.data.map((val) => {
                    return {
                        x: val.countryCode,
                        y: val.count
                    }
                })
            };
            dispatch({type: COUNT_PER_COUNTRIES_BY_BRAND_NAME_SUCCESS, payload: data});
        })
        .catch(error => console.warn(error))
};

export const getDrugsCountPerManufacturer = () => dispatch => {
    axios.get("/drugs/statistics/manufacturers")
        .then(response => {
            dispatch({
                type: DRUGS_COUNT_PER_MANUFACTURER_FETCH_SUCCESSFULLY, payload: response.data
                    .filter(x => x.countryCode != null)
                    .map(x => {
                        const manufacturerName = x.countryCode.toUpperCase();
                        return {
                            label: manufacturerName,
                            value: x.count
                        }
                    })
            });
        })
        .catch(error => console.warn(error));
};

export const searchManufacturersByName = (name) => dispatch => {
    axios.get("/company/search", {params: {name: name}})
        .then(response => {
            dispatch({type: COMPANY_SEARCH_RESULT_SUCCESS, payload: response.data});
        })
        .catch(error => console.warn(error));
};

export const getStatisticsForCompany = (name) => dispatch => {
    dispatch({type: COMPANY_STATISTICS_FETCH});
    axios.get("/company/statistics", {params: {companyName: name}})
        .then(response => {
            dispatch({type: COMPANY_STATISTICS_FETCH_SUCCESS, payload: response.data});
        })
        .catch(error => console.warn(error))
};

export const getStatisticsForCompanyOpponent = (name) => dispatch => {
    dispatch({type: COMPANY_OPPONENT_STATISTICS_FETCH});
    axios.get("/company/statistics", {params: {companyName: name}})
        .then(response => {
            dispatch({type: COMPANY_OPPONENT_STATISTICS_FETCH_SUCCESS, payload: response.data});
        })
        .catch(error => console.warn(error))
};

export const getDrugsForCountryByAtc = (countryName, atcCode) => dispatch => {
    axios.get(`/drugs/${countryName.toUpperCase()}/atc/${atcCode}`)
        .then(response => {
            dispatch({
                type: DRUGS_COUNTRY_ATC,
                payload: response.data
            })
        })
}

export const clearSelection = () => dispatch => {
    dispatch({type: CLEAR_OPPONENT_SELECTION});
};
